export const SWAP_ANIMATION_DURATION = 1000;
export const JUMP_ANIMATION_DURATION = 300;
export const JUMP_BLOCK_DURATION_GAP = 100;
export const JUMP_ANIMATION_END_DELAY = 50;
export const WIN_MODAL_DELAY = 2200;
export const LOSE_MODAL_DELAY = 600;
export const LOSE_ROW_ANIMATION_DELAY = 1000;
export const SHAKRE_ANIMATION_DELAY = 500;
